import { render, staticRenderFns } from "./VformShow.vue?vue&type=template&id=7150e7da&scoped=true&"
import script from "./VformShow.vue?vue&type=script&lang=js&"
export * from "./VformShow.vue?vue&type=script&lang=js&"
import style0 from "./VformShow.vue?vue&type=style&index=0&id=7150e7da&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7150e7da",
  null
  
)

export default component.exports